var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stats',{attrs:{"headline":_vm.headline}},[_c('stat',{attrs:{"name":_vm.$t('shared.modals.adjust_max_price_modal.adjust_overview.max_price'),"value":_vm.maxPrice}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }